<template>
  <div class="contatiner">
    <h1>输入报考院校</h1>
    <div class="input_div input_fu" >
      <input class="input" v-model="content" type="text" placeholder="输入你想添加的院校名称">
    </div>
    <div class="btn" @click="feedback">
      <van-loading type="spinner" color="#ffffff" v-if="loading" />
      <span v-if="!loading">确定</span> 
     </div>
    <div class="text_div">
      <div class="h3">小白提示</div>
      <div class="p">全国高校数量众多，部分高校可能暂无Q群，快给小白申请吧，我们会第一时间为你新建新的高校群哦～</div>
    </div>
  </div>
</template>

<script>
  import {
    Notify,
    Loading,
  } from 'vant'
  import {
    Toast,
  } from 'vant';
  import {
    setOpenid,
    getOpenid
  } from '../../util/auth'
  import {
    createHash
  } from '../../util/hash'
  import https from '../../https'
  // var QRCode = require('qrcode')
  export default {
    components: {
      [Notify.name]: Notify,
      [Loading.name]: Loading,
    },
    data() {
      return {
        kf: "",
        url_img: "",
        content:"",
        loading:false,
      }
    },
    created() {
    this.content = this.$route.query.name?this.$route.query.name:"";
    },
    methods: {
      feedback() {
        if(!this.content){
          Toast('不得为空！');
          return;
        }
        this.loading = true
        https.fetchPost(`/api/feedback`, { content: this.content, typeText: "申请新增院校QQ群" }).then(res => {
          if (res.data && res.data.data) {
           Toast.success('提交成功');
          }
          this.loading = false
        }).catch(err => {
          Toast.fail('提交失败');
          console.log(err)
        })
      
      },
      copyqun(e, value) {
        try {
          value = value || '2690414527'
          const input = document.createElement('textarea')
          input.value = value
          document.body.appendChild(input)
          input.select()
          document.execCommand('Copy')
          document.body.removeChild(input)
          Toast.success('QQ群号复制成功');
        } catch (e) {
          Toast.fail('复制失败');
        }
      },
      copy(e, value) {
        try {
          value = value || '2690414527'
          const input = document.createElement('textarea')
          input.value = value
          document.body.appendChild(input)
          input.select()
          document.execCommand('Copy')
          document.body.removeChild(input)
          Toast.success('客服QQ号复制成功');
        } catch (e) {
          Toast.fail('复制失败');
        }
      }
    }
  }
</script>
<style>
  html{
    height: 100%;
    width: 100%;
    background-color: #fff;
    overflow: hidden;
  }
</style>
<style scoped="scoped">
  .text_div{
    padding: 0  30px;
  }
  .h3{
    width: 144px;
    height: 46px;
    background: #FFE65F;
    border-radius: 8px;
    text-align: center;
    line-height: 46px;
    font-size: 28px;
    color:#000;
    font-weight: bold;
  }
  .p{
    color: #666666;
    font-size: 28px;
    line-height: 48px;
    margin-top: 18px;
  }
  .contatiner {
    border-top: 1px solid #EAEAEA;
    background-color: #fff;
  }

  h1 {
    font-size: 36px;
    margin-top: 40px;
    line-height: 50px;
    text-align: center;
  }
  .input{
    width: 690px;
    height: 98px;
    background: #F6F6F6;
    border-radius: 20px;
    border: none;
    padding: 0 30px;
    box-sizing: border-box;
    font-size: 32px;
  }
  .input_fu{
    width: 690px;
    height: 98px;
    margin: 26px auto 0;
  }
  .btn{
    width: 660px;
    height: 88px;
    background: linear-gradient(84deg, #2AC59A 0%, #00C080 100%);
    box-shadow: 0px 10px 20px 0px rgba(0, 192, 128, 0.33);
    border-radius: 44px;
    margin:  54px auto 80px;
    text-align: center;
    font-weight: bold;
    font-size: 36px;
    color: #fff;
    line-height: 88px;
  }
</style>
